export default function PageHeader({ title, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
      <div className="space-y-1">
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900" data-testid="page-title">
          {title}
        </h1>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
